import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-fake-page-preview',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './fake-page-preview.component.html',
  styleUrls: ['./fake-page-preview.component.scss']
})
export class FakePagePreviewComponent {
  @Input() isAdmin: boolean = false;
}
